import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    accountSearchResultLicensedUsersDataSelector,
    accountSearchResultLicensedUsersResultSelector,
} from '../../slices/account-search-result-licensed-users.slice';

type Props = {
    accountId: number,
};

export const LicensedEnabledUsersCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultLicensedUsersDataSelector);
    const result = useSelector(accountSearchResultLicensedUsersResultSelector);

    const count = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !count) {
        return null;
    }

    return (
        <AccountLink
            accountId={accountId}
            place={PLACE}
            accountName={count.toString()}
            target="users-groups/licensed"
        />
    );
};
